import React from 'react'
import { Checkbox, FormikCheckboxGroup, Label, Tooltip } from '@babylon/core-ui'
import { useField } from 'formik'
import styles from './AdditionalAppointmentSlotTypeSelector.module.css'

export enum AdditionalAppointmentSlotType {
  reservedSlot = 'reserved',
  urgentSlot = 'urgent',
}

const AdditionalAppointmentSlotTypeSelector = () => {
  const [{ value }] = useField('additional_appointment_slot_types')

  return (
    <>
      <div className={styles.title}>
        <Label htmlFor="appointmentSlotType">Appointment slot type</Label>
        <Tooltip
          info="Optional - selection allows this invite to book into reserved and/or urgent slots.
          Regular (public) slots are always accessible by an invite."
          placement="right"
        />
      </div>
      <FormikCheckboxGroup
        name="additional_appointment_slot_types"
        id="additional_appointment_slot_types"
      >
        <div className={styles.checkBoxGroupContainer}>
          <Checkbox
            value={AdditionalAppointmentSlotType.reservedSlot}
            checked={value.includes(AdditionalAppointmentSlotType.reservedSlot)}
            type="checkbox"
          >
            Reserved slots
          </Checkbox>
          <Checkbox
            value={AdditionalAppointmentSlotType.urgentSlot}
            checked={value.includes(AdditionalAppointmentSlotType.urgentSlot)}
            type="checkbox"
          >
            Urgent slots
          </Checkbox>
        </div>
      </FormikCheckboxGroup>
    </>
  )
}

export default AdditionalAppointmentSlotTypeSelector
